import type { Technique } from '../types';
import { SHATTER_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type ShatterState } from './render';

export const shatter: Technique<ShatterState> = {
  id: 'shatter',
  name: 'Zerfall / Shatter',
  category: 'physics',
  description: 'Die Buchstaben brechen in Scherben und fallen unter Schwerkraft auseinander.',
  params: SHATTER_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
